import type { ReactNode } from 'react';

/**
 * One row of PalmettoDataGrid's overflow menu (its `MenuItems` slot). The grid draws that menu
 * itself and closes it on any click inside the slot, so the row is a plain button styled like
 * the grid's own rows; eti-ui's DropdownMenuItem only works inside an eti-ui DropdownMenu.
 */
const GridMenuItem = ({ onClick, children }: { onClick: () => void; children: ReactNode }) => (
  <button
    type='button'
    role='menuitem'
    onClick={onClick}
    className='rep:flex rep:w-full rep:min-h-9 rep:cursor-pointer rep:items-center rep:px-4 rep:py-1.5 rep:text-left rep:text-base rep:text-black/87 rep:hover:bg-black/4 rep:focus-visible:bg-black/8 rep:focus-visible:outline-none'>
    {children}
  </button>
);

export default GridMenuItem;
